<template>
  <header class="header">
    <div v-if="isHomePage" class="inner">
      <div class="sidebar-icon" @click="handleShowSidebar">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
      <div class="logo-wrapper">
        <div class="logo"></div>
        <div class="line"></div>
        <h2 class="title">创作者服务平台</h2>
      </div>
    </div>
    <div v-else-if="isDetailPage" class="inner-detail">
      <div class="back-icon" @click="handleBack">
        <!-- <van-icon name="down" size="38" class="back"> </van-icon> -->
        <van-icon name="arrow-left" size="24" class="back"> </van-icon>
      </div>
      <p class="title">{{ $route.meta.pageTitle || $route.meta.title }}</p>
    </div>
    <div
      v-else
      class="inner back-header"
      :class="{ hidden: $route.meta.hideTitle === true }"
    >
      <p class="home-title" v-if="isLastHome">
        {{ $route.meta.pageTitle || $route.meta.title }}
      </p>
      <p class="studio-title" v-else-if="$route.name == 'dataDetails'">
        {{ $route.meta.pageTitle || $route.meta.title }}
      </p>
      <p
        :class="[
          $route.name == 'StudioIncomeSettlement' ? 'title active' : 'title',
        ]"
        v-else
      >
        {{ $route.meta.pageTitle || $route.meta.title }}
      </p>
      <div class="sidebar-icon" @click="handleShowSidebar" v-if="isLastHome">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
      <div class="back" @click="handleBack" v-else>
        <van-icon name="arrow-left" size="24" class="back1"> </van-icon>
      </div>
      <div class="tip-desc" @click="openTip">
        {{ $route.meta.desc }}
      </div>
    </div>

    <van-popup
      v-model="sidebarVisible"
      position="left"
      :style="{ width: '80%', height: '100%' }"
    >
      <div class="sidebar-wrapper">
        <div class="sidebar-title">
          <div class="logo"></div>
          <div class="right-icon" @click="handleHideSidebar"></div>
        </div>
        <div class="sidebar-menu">
          <div
            class="sidebar-menu-item"
            v-for="route of routes"
            :key="route.name"
          >
            <template v-if="!route.hidden">
              <!-- 有子菜单 -->
              <div v-if="hasMoreThanOneChild(route)">
                <div class="title-wrapper" @click="handleToggle(route)">
                  <i
                    v-if="route.meta.icon"
                    class="menu-icon"
                    :class="route.meta.icon"
                  ></i>
                  <span class="title">{{ route.meta.title }}</span>
                  <van-icon
                    :name="
                      currentMenuPath === route.path ? 'arrow-up' : 'arrow-down'
                    "
                  ></van-icon>
                </div>
                <!-- 子菜单 -->
                <div
                  class="sidebar-sub-menu-item"
                  v-show="currentMenuPath === route.path"
                >
                  <div
                    v-for="child of filterRoutes(route.children)"
                    :key="child.path"
                    class="title-wrapper"
                    @click="handleMenuItemClick(route.path, child.path)"
                    :class="{
                      current:
                        resolvePath(
                          route.meta.activePath || route.path,
                          child.path,
                        ) === defaultActivePath,
                    }"
                  >
                    <span class="title">{{
                      child.meta && child.meta.title
                    }}</span>
                  </div>
                </div>
              </div>
              <!-- 无子菜单 -->
              <div v-else>
                <div
                  class="title-wrapper"
                  @click="handleMenuItemClick(route.path)"
                  :class="{
                    current:
                      resolvePath(route.meta.activePath || route.path) ===
                      defaultActivePath,
                  }"
                >
                  <i
                    v-if="route.meta.icon"
                    class="menu-icon"
                    :class="route.meta.icon"
                  ></i>
                  <span class="title">{{ route.meta.title }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="isRuleVisible"
      closeable
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="rule-wrapper">
        <div class="title">数据说明</div>
        <slot name="regular">
          <pre>
下载次数：地图作品被玩家下载的累计次数
浏览次数：地图作品详情页（工坊或大厅内）被玩家查看的累计次数
游玩次数：地图作品被玩家进入游玩累计次数
游玩时长：地图作品被玩家进入停留游玩的累计时长
评论数：地图作品被玩家评论的累计次数
投块数：地图作品获得投块的累计数
点赞数：地图作品获得玩家点赞的累计次数
收藏数：地图作品被玩家收藏的累计次数
广告收益：玩家观看作品内的广告后产生的收益；
广告展示：地图作品内的玩家点击播放广告的次数；
贡献点：玩家使用迷你币消费您的作品或道具；
迷你点：玩家使用迷你点购买了作品或资源
迷你豆：玩家使用迷你豆购买了作品或资源；
      </pre
          >
        </slot>
      </div>
    </van-popup>
  </header>
</template>

<script>
import path from 'path';
import { mapState } from 'vuex';
import { downloadData } from '../../api/charts';
// import HelpRule from './HelpRule.vue';
export default {
  data() {
    return {
      sidebarVisible: false,
      currentMenuPath: '',
      isRuleVisible: false,
    };
  },
  // comments: {
  //   HelpRule,
  // },
  computed: {
    ...mapState(['routes']),
    defaultActivePath() {
      console.log(this.$route);
      const { path, meta } = this.$route;
      let newPath = path;

      // 如果需要特殊的高亮，例如在 B 页面时，高亮显示 A 菜单。可以在 meta 中添加 activePath 额外处理
      if (meta.activePath) {
        // 获取根路径
        const currentRootPath = '/' + path.slice(1).split('/').shift();
        // 拼接 activePath
        newPath = [currentRootPath, meta.activePath].join('/');
      }
      return newPath;
    },
    // 是否首页，首页显示 logo 和 菜单栏
    isHomePage() {
      const { path } = this.$route;

      // 判断只有一个  /
      // const isHome = this.$route.query.last == 1;
      const bool = ['/', '/home'].includes(path);
      return bool;
    },
    isLastHome() {
      const showSideBar = this.$route.meta.showSideBar;
      const lastHome = showSideBar === 'true' || showSideBar === true;
      return lastHome;
    },
    //是否打开说明页
    //是否详情页
    isDetailPage() {
      const name = this.$route.name;
      return name == 'detailPage' ? true : false;
      //  if(this.$route.name=='detailPage')return 1
    },
  },
  mounted() {
    // console.log(this.$route, '$route');
  },
  methods: {
    // 没有 hidden 属性 的 子路由 大于 1个
    hasMoreThanOneChild({ children = [] }) {
      return (
        children.length > 1 && children.filter(item => !item.hidden).length >= 1
      );
    },
    openTip() {
      //  this.isRuleVisible = true;
      this.$router.push({ name: 'Hiptip' });
    },
    //导出作品列表
    downloadData() {},
    // 过滤路由
    filterRoutes(routes) {
      return routes.filter(route => !route.hidden);
    },
    resolvePath(basePath, routePath = '') {
      return path.resolve(basePath, routePath);
    },
    handleMenuItemClick(basePath, routePath = '') {
      const path = this.resolvePath(basePath, routePath);
      console.log(path);
      if (path === this.$route.path) {
        return;
      }
      this.$router.push({ path });

      this.handleHideSidebar();
    },
    handleShowSidebar() {
      this.sidebarVisible = true;
    },
    handleHideSidebar() {
      this.sidebarVisible = false;
    },
    // 展开/收起 子菜单
    handleToggle(route) {
      if (this.currentMenuPath === route.path) {
        this.currentMenuPath = '';
      } else {
        this.currentMenuPath = route.path;
      }
    },
    // 返回上一页
    handleBack() {
      const { meta } = this.$route;
      console.log(meta, 'meta');
      if (meta.backToHome) {
        this.$router.push('/');
      } else {
        this.$router.back();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;

  .inner {
    display: flex;
    height: 80px;
    padding: 0 6px;
    align-items: center;
    font-size: 24px;
    // justify-content: space-between;
    &.back-header {
      display: flex;
      text-align: center;
      line-height: 80px;
      color: #262626;
      font-size: 30px;
      position: relative;
      width: 100%;
      &.hidden {
        display: none;
      }
      .back {
        position: absolute;
        top: 0;
        left: 34px;
        height: 80px;
        z-index: 2;
        .van-icon {
          width: 18px;
          height: 35px;
          //  background: #03081a;
          margin-top: 20px;
        }
      }
      .home-title {
        font-size: 36px;
        font-weight: 500;
        margin-left: 150px;
        color: #000000;
        position: absolute;
        margin: auto;
        width: 100%;
        z-index: 1;
      }
      .studio-title {
        font-size: 36px;
        font-weight: 500;
        margin-left: 200px;
        color: #000000;
      }
      .title {
        font-size: 36px;
        font-weight: 500;
        margin-left: 303px;
        color: #000000;
      }
      .title.active {
        margin-left: 250px;
      }
      .tip-desc {
        margin-left: 133px;
        color: #8c8c8c;
        font-size: 36px;
      }
      .download-data {
        margin-left: 140px;
        color: #2b6ddfff;
        font-size: 36px;
      }
    }
  }
  .rule-wrapper {
    padding: 20px 20px;
    line-height: 40px;
    color: #262626;
    .title {
      padding: 20px 0;
      font-size: 30px;
      font-weight: bold;
      text-align: center;
    }

    > p {
      padding-bottom: 20px;
      font-size: 26px;
    }
    pre {
      white-space: pre;
      font-size: 24px;
      line-height: 1.5;
      color: #262626;
      overflow: hidden;
    }
  }
  .inner-detail {
    display: flex;
    height: 80px;
    padding: 0 6px;
    align-items: center;
    justify-content: center;
    color: #3d3c3c;
    .back-icon {
      // .back {
      //   top: 0;
      //   position: absolute;
      //   left: 30px;
      //   transform: rotate(90deg);
      // }
      .back {
        position: absolute;
        top: 0;
        left: 34px;
        height: 80px;
        margin-top: 20px;
        .van-icon {
          width: 18px;
          height: 35px;
          //  background: #03081a;
          margin-top: 20px;
        }
      }
    }
    .title {
      text-align: center;
      font-size: 40px;
      font-weight: 600;
      line-height: 60px;
    }
  }
  .sidebar-icon {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 102px;
    height: 25px;
    padding: 0 36px;
    z-index: 2;
    .line {
      width: 100%;
      height: 4px;
      background-color: #497db1;
      border-radius: 6px;
    }
  }

  .logo-wrapper {
    display: flex;
    align-items: center;

    .logo {
      width: 114px;
      height: 38px;
      background: url(~@/assets/images/icon_logo.png) no-repeat;
      background-size: contain;
    }
    .line {
      width: 1px;
      height: 20px;
      margin: 0 23px;
      background: #d9d9d9;
    }
    .title {
      font-size: 24px;
      line-height: 24px;
      color: #497db1;
    }
  }

  .info-wrapper {
    .avatar {
      display: block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      cursor: pointer;
    }
  }
}

.sidebar-wrapper {
  height: 100%;
  background-color: #fff;

  .sidebar-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100px;
    padding-left: 32px;
    background-color: #262626;

    .logo {
      width: 114px;
      height: 38px;
      background: url(~@/assets/images/icon_logo.png) no-repeat;
      background-size: contain;
    }

    .right-icon {
      width: 90px;
      height: 90px;
      background: url(~@/assets/images/blue-arrow.png) center no-repeat;
      background-size: 26px 26px;
    }
  }

  .sidebar-menu {
    margin-top: 40px;
    font-size: 28px;
  }

  .sidebar-menu-item {
    .title-wrapper {
      display: flex;
      align-items: center;
      min-height: 100px;
      padding: 0 32px;
      font-size: 28px;
      color: #262626;
      &.current {
        background-color: #fffaed;
        color: #fd9b21;

        .icon-home {
          background-image: url(~@/assets/images/icon_home_active.png);
        }
        .icon-income {
          background-image: url(~@/assets/images/icon_income_active.png);
        }
        .icon-charts {
          background-image: url(~@/assets/images/icon_charts_active.png);
        }
        .icon-account {
          background-image: url(~@/assets/images/icon_account_active.png);
        }
        .icon-studio {
          background-image: url(~@/assets/images/ico_studio_active.svg);
        }
        .icon-cloudServ {
          background-image: url(~@/assets/images/ico_cloudServ_active.svg);
        }
      }
    }

    .title {
      flex: 1;
      line-height: 100px;
    }

    > .sidebar-menu-item {
      width: 100%;
      padding-left: 94px;
    }

    .menu-icon {
      display: inline-block;
      width: 30px;
      height: 30px;
      margin-right: 32px;

      background-repeat: no-repeat;
      background-size: contain;
      vertical-align: middle;
    }
    .icon-home {
      background-image: url(~@/assets/images/icon_home.png);
    }
    .icon-income {
      background-image: url(~@/assets/images/icon_income.png);
    }
    .icon-charts {
      background-image: url(~@/assets/images/icon_charts.png);
    }
    .icon-activity {
      background-image: url(~@/assets/images/icon_activity.png);
    }
    .icon-account {
      background-image: url(~@/assets/images/icon_account.png);
    }
    .icon-studio {
      background-image: url(~@/assets/images/ico_studio.svg);
    }
    .icon-cloudServ {
      background-image: url(~@/assets/images/ico_cloudServ.svg);
    }
  }

  .sidebar-sub-menu-item {
    .title-wrapper {
      padding-left: 94px;
    }
  }
}
</style>
